import clsx from "clsx";
import * as React from "react";
import styles from "./label-component.module.scss";

export interface ILabelComponentComponentProps {
  /** Drives the colour class (`styles[type.toLowerCase()]`), e.g. "live", "offline", "success". */
  type?: string;
  /** Optional display text; falls back to `type` when omitted (keeps existing call sites unchanged). */
  label?: string;
}

const LabelComponent = (props: ILabelComponentComponentProps) => {
  const typeClass = props.type ? props.type.toLowerCase() : "";

  return <div className={clsx(styles.label, styles[typeClass])}>{props.label ?? props.type}</div>;
};

export { LabelComponent };
